import Slide from './Slide'
import Slider from './Slider'
import SliderArrows from './SliderArrows'

export { Slide, Slider, SliderArrows }
